import { Box, Text } from '@chakra-ui/react';

const DescriptionDisplay = ({ darkMode, value }) => {
    return (
        <Box mb={6}>
            <Text 
                fontWeight="semibold" 
                color={darkMode ? 'white' : 'gray.700'}
                mb={2}
            >
                Description
            </Text>
            <Text 
                color={darkMode ? 'gray.300' : 'gray.600'}
                fontSize="md"
            >
                {value}
            </Text>
        </Box>
    );
};

export default DescriptionDisplay;